import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMachineDetailsRobotSchedule } from '../../context/MachineDetailsRobotScheduleContext';
import { IconContainer, ScheduleBannerAlert } from './ScheduleBanner.styles';
import { SvgIcon } from 'lib/components/SvgIcon/SvgIcon';

export const ScheduleBanner = (): JSX.Element | null => {
  const { t } = useTranslation();
  const { isRobotOnline, isRobotVersionSupported } = useMachineDetailsRobotSchedule();
  const [isDismissed, setIsDismissed] = useState(false);

  if (isDismissed || (isRobotOnline && isRobotVersionSupported)) {
    return null;
  }

  const message = !isRobotVersionSupported
    ? t('machineDetails.robotSchedule.outdatedFirmwareBanner')
    : t('machineDetails.robotSchedule.deviceNotOnlineBanner');

  return (
    <ScheduleBannerAlert
      icon={
        <IconContainer>
          <SvgIcon name="warningNew" />
        </IconContainer>
      }
      closeIcon={
        <IconContainer>
          <SvgIcon name="cancel" />
        </IconContainer>
      }
      message={message}
      type="warning"
      showIcon
      closable
      onClose={(): void => setIsDismissed(true)}
    />
  );
};
